import Image from "next/image"
import logo from '@/public/images/RM_logo_V2.png'
import FooterSocials from "@/app/components/base/FooterSocials"
import Link from "next/link"
import {getContextLinks} from "@/app/utils/context-utils"
import FooterLegalLead from "@/app/components/base/FooterLegalLead"

export default function FooterNewView({pathname, year}: {pathname: string; year: number}) {
    const linksToDisplay = getContextLinks(pathname)

    return (
        <footer
            id="rm-footer"
            className="flex flex-col w-full gap-[32px] bg-pale px-[16px] py-[32px] lg:pt-[80px] lg:pb-[24px] text-white"
        >
            <div className="flex flex-col justify-center lg:flex-row w-full gap-[32px] lg:gap-[40px] max-w-7xl mx-auto">
                <div className="flex flex-col gap-[32px] lg:max-w-[200px] lg:h-max lg:justify-between">
                    <div className="w-full flex lg:flex-col justify-between items-center lg:gap-[16px]">
                        <Image className="brightness-0 invert" alt="Comparateur Assurance" src={logo} width={120} height={47} />

                        <span className="hidden lg:flex text-rm-gray">
                            Le comparateur d'assurance le mieux noté depuis 2013
                        </span>
                    </div>

                    <div className="flex lg:flex-col lg:h-full gap-[12px] md:gap-[8px]">
                        <Link className="hover:underline" href="/guide/a-propos/comment-ca-marche">
                            Comment ça marche ?
                        </Link>
                        <span className="block md:hidden">
                            •
                        </span>
                        <Link className="hover:underline" href="/guide/a-propos/reclamation">
                            Réclamation
                        </Link>
                        <span className="block md:hidden">
                            •
                        </span>
                        <Link className="hover:underline" href="/guide/partenaires">
                            Partenaires
                        </Link>
                    </div>

                    <div>
                        <FooterSocials />
                    </div>
                </div>

                <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-2 lg:grid-cols-4 w-full gap-[32px] md:gap-none">
                    {Object.keys(linksToDisplay).map((category, index) => (
                        <div className="flex flex-col gap-[12px]" key={index}>
                            <span className="p-[6px] bg-rm-blue w-fit rounded-[6px] title-look">{category}</span>

                            <ul className="flex flex-col gap-2">
                                {linksToDisplay[category].map((linksToDisplay, index) => (
                                    <li key={index}>
                                        <Link className="hover:underline" href={linksToDisplay.url}>
                                            {linksToDisplay.text}
                                        </Link>
                                    </li>
                                ))}
                            </ul>
                        </div>
                    ))}
                </div>
            </div>

            <div className="py-[32px] border-y md:border-b-0 border-white/30 opacity-80 md:mt-24 max-w-7xl mx-auto">
                <FooterLegalLead />
            </div>

            <div className="flex flex-col md:flex-row-reverse gap-[32px] justify-between text-[12px] opacity-80 items-center max-w-7xl mx-auto">
                <div className="flex flex-col md:flex-row justify-center items-center w-full md:w-fit gap-[16px] md:gap-[32px] md:opacity-50">
                    <Link className="w-fit hover:underline" href="/guide/cgu-cgv">
                        Conditions générales d'utilisation
                    </Link>

                    <div className="flex justify-center gap-[16px] md:gap-[32px]">
                        <Link className="w-fit hover:underline" href="/guide/politique-confidentialite">
                            Politique de confidentialité
                        </Link>
                        <span className="block md:hidden">
                            •
                        </span>
                        <Link className="w-fit hover:underline" href="/guide/politique-cookies">
                            Politique de cookies
                        </Link>
                    </div>

                    <div className="flex justify-center gap-[16px] md:gap-[32px]">
                        <Link className="w-fit hover:underline" href="/guide/a-propos/mentions-legales">
                            Mentions légales
                        </Link>
                        <span className="block md:hidden">
                            •
                        </span>
                        <Link className="w-fit hover:underline" href="/guide/a-propos/comment-ca-marche">
                            Mentions comparateurs
                        </Link>
                    </div>
                </div>

                <span className="opacity-50">© Réassurez-moi {year}. Tous droits réservés.</span>
            </div>
        </footer>
    )
}
